// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"5df6e141","289":"41ccca28","736":"5df6e141","793":"5df6e141"}[chunkId] + ".chunk.css";
};